import { render, staticRenderFns } from "./DocumentSectionEditCreate.vue?vue&type=template&id=25365a63&"
import script from "./DocumentSectionEditCreate.vue?vue&type=script&lang=js&"
export * from "./DocumentSectionEditCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports